import { GET_USER_ADDRESS_REQUEST, GET_USER_ADDRESS_REQUEST_SUCCESS, GET_USER_ADDRESS_REQUEST_FAILURE } from '../../constants/user_address.constants';

export const getUserAddressRequest = _id => ({ type: GET_USER_ADDRESS_REQUEST, _id });
export const getUserAddressRequestSuccess = payload => ({ type: GET_USER_ADDRESS_REQUEST_SUCCESS, payload });
export const getUserAddressRequestFailure = error => ({ type: GET_USER_ADDRESS_REQUEST_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/actions/user_addresses_actions/get_user_address.action.js